import { useState, useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { TypingInsertResultResponseDataExpTypeEnum } from '../api';
import { isOnlineUserAtom } from '../atom/Atom';

interface WindowExpProps {
  expPoint: number;
  expType: TypingInsertResultResponseDataExpTypeEnum;
}

const getExpTypeMessage = (expType: TypingInsertResultResponseDataExpTypeEnum): string => {
  switch (expType) {
    case TypingInsertResultResponseDataExpTypeEnum.FirstClear:
      return 'はじめてクリア！';
    case TypingInsertResultResponseDataExpTypeEnum.Clear:
      return 'タイピングクリア！';
    case TypingInsertResultResponseDataExpTypeEnum.Play:
      return 'タイピングプレイ！';
    case TypingInsertResultResponseDataExpTypeEnum.Null:
      return 'タイピングプレイ！';
    default:
      return 'タイピングプレイ！';
  }
};

export const WindowExp = ({expPoint, expType}: WindowExpProps) => {
  const DIGITANE_LOGO_PATH = '/common/digitane.webp';
  const [showExpModal, setShowExpModal] = useState(false);
  const isOnlineUser = useAtomValue(isOnlineUserAtom);

  useEffect(() => {
    let isMounted = true;
    let timeoutId: ReturnType<typeof setTimeout> | null = null;
    const showModalsSequentially = async () => {
      if (expPoint > 0) {
        setShowExpModal(true);
        await new Promise<void>((resolve) => {
          timeoutId = setTimeout(resolve, 5000);
        });
        if (isMounted) {
          setShowExpModal(false);
        }
      }
    };
    showModalsSequentially();
    return () => {
      isMounted = false;
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
      }
    };
  }, [expPoint, expType]);

  if (!isOnlineUser) {
    return null;
  }
  
  return (
    <>
      {showExpModal && (
        <div className="fixed top-5 right-5 z-[500] flex min-h-[80px] w-[224px] items-center justify-center gap-1 rounded-[16px] border-4 border-[#1276b5] bg-white py-2 text-base font-bold animate-fade-in-out">
          <img
            className="h-8"
            src={DIGITANE_LOGO_PATH}
            alt="Digitane Logo"
          />
          <div className="w-[150px] whitespace-pre-wrap text-center font-bold leading-5 tracking-[-0.5px] text-[#1276b5]">
            <div>{getExpTypeMessage(expType)}</div>
            <div>
              +<span className="text-xl">{expPoint}</span> EXP
            </div>
          </div>
        </div>
      )}
    </>
  );
};
